<template>
  <div class="pwc-event">
    <van-swipe v-if="banner" :autoplay="3000" class="pwc-event-banner">
      <van-swipe-item
        v-for="(event, index) in cSwipList"
        :key="index"
        @click="handleGoDetail(event)"
      >
        <img :src="event.coverUrl">
      </van-swipe-item>
    </van-swipe>

    <div v-if="cEventList.length > 0" class="pwc-event-list">
      <van-card
        v-for="(event, index) in cEventList"
        :key="index"
        :title="event.eventName"
        :thumb="(event.coverUrl||'').trim()"
        class="pwc-event-item"
        @click="handleGoDetail(event)"
      >
        <div slot="thumb">
          <img :src="(event.coverUrl||'').trim()">
        </div>
        <div slot="tags" class="pwc-event-date">
          <span>{{ event.startTime | dateYMD }}</span>
        </div>
        <div slot="num">
          <span>{{ event.location }}</span>
        </div>
        <div slot="footer">
          <van-button
            v-if="action"
            :disabled="event.isRegisted"
            plain
            hairline
            type="primary"
            size="mini"
            @click.stop="handleGoDetail(event)"
          >{{ event.registerText }}</van-button>
        </div>
      </van-card>
    </div>

    <no-data v-if="cEventList.length === 0" />
  </div>
</template>

<script>
import NoData from '../../NoData'
import { Swipe, Card, SwipeItem, Button } from 'vant'

export default {
  components: {
    VanSwipe: Swipe,
    VanCard: Card,
    VanSwipeItem: SwipeItem,
    VanButton: Button,
    //
    NoData
  },
  props: {
    events: {
      type: Array,
      default: () => []
    },
    banner: {
      type: Boolean,
      default: true
    },
    action: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    cSwipList() {
      if (this.banner) {
        const events = this.events.slice(0, 2)
        //  maybe need some map action later
        return events
      }
      return []
    },
    cEventList() {
      if (this.banner) {
        const events = this.events.slice(2)
        //  maybe need some map action later
        return events.map(v => {
          return Object.assign({}, v, {
            registerText: v.isRegisted ? '已报名' : '报名'
          })
        })
      }
      return this.events.slice().map(v => {
        return Object.assign({}, v, {
          registerText: v.isRegisted ? '已报名' : '报名'
        })
      })
    }
  },
  methods: {
    handleGoDetail(event) {
      this.$emit('go:event:detail', event)
    },
    handleRegister(event) {
      this.$emit('register', event)
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-event {
    .pwc-event-banner {
        height: 220px;
        margin-bottom: 10px;
        img {
            height: 100%;
            width: 100%;
        }
    }
    .pwc-event-list {
      margin-top: 6px;
      .pwc-event-item {
        .pwc-event-date {
            margin-top: 10px;
        }
        img {
            width:100%;
            height: 100%;
        }
      }
    }
}
</style>

<style lang="scss">
.pwc-event {
    .pwc-event-item {
        background-color: #fff;
        .van-card__thumb {
            width: 120px;
        }
    }
}
</style>

